export const DEFAULT_DELAY_SHOW_ALERT_IN_MILLISECONDS = 3000;

export const SUCESSFUL_GENERATED_PROJECT_REPORT = {
  message: "one_pager_report.successful_download_message",
  severity: "success"
}

export const SUCESSFUL_GENERATED_PORTFOLIO_REPORT = {
  message: "one_pager_report.successful_portfolio_download_message",
  severity: "success"
}

export const SUCESSFUL_GENERATED_AGREEMENT_REPORT = {
  message: "one_pager_report.successful_agreement_download_message",
  severity: "success"
}

export const ERROR_IN_GENERATE_REPORT = {
  message: "one_pager_report.error_download_message",
  severity: "error"
}

export const SUCESSFUL_CREATE_NEW_ACCORDANCE = {
  message: "successful_create_new_accordance",
  severity: "success"
}

export const SUCESSFUL_SEND_FOR_APPROVAL_ACCORDANCE = {
  message: "successful_send_for_approval_accordance",
  severity: "success"
}

export const SUCESSFUL_DELETE_ACCORDANCE = {
  message: "successful_deleted_accordance",
  severity: "success"
}

export const SUCESSFUL_APPROVED_ACCORDANCE = {
  message: "successful_approved_accordance",
  severity: "info"
}

export const SUCESSFUL_REJECTED_ACCORDANCE = {
  message: "successful_rejected_accordance",
  severity: "info"
}

export const ERROR_UNSAVED_ACCORDANCE = {
  message: "error_unsaved_accordance",
  severity: "error"
}
